import Vue from "vue";
import App from "./App.vue";

window.Vue = Vue;

import router from "./router";
import store from "./store";

import miniToastr from "./lib/minitoastr";
import VueCookies from "vue-cookies";
import VueI18n from "vue-i18n";
import JsonCSV from "vue-json-csv";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueGoogleCharts from "vue-google-charts";
import CKEditor from "@ckeditor/ckeditor5-vue";
import DatePicker from "vue2-datepicker";

import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import VueSimpleContextMenu from "vue-simple-context-menu";
Vue.component("vue-simple-context-menu", VueSimpleContextMenu);

import moment from "moment";

Vue.use(VueCookies);
Vue.use(VueI18n);
Vue.use(Loading);
Vue.use(CKEditor);
Vue.use(DatePicker);

Vue.component("downloadCsv", JsonCSV);
Vue.use(VueGoogleCharts);

const messages = {
  en: require("../locales/en.json"),
  it: require("../locales/it.json"),
  de: require("../locales/de.json"),
  es: require("../locales/es.json"),
  fr: require("../locales/fr.json"),
  nl: require("../locales/nl.json"),
  cr: require("../locales/cr.json"),
};

const i18n = new VueI18n({
  locale: "it",
  fallbackLocale: "en",
  messages,
});

Vue.config.productionTip = false;

Vue.prototype.$miniToastr = miniToastr;

window.GlobalEventBus = new Vue();

Vue.prototype.$moment = moment;

new Vue({
  router,
  store,
  i18n,
  moment,
  render: (h) => h(App),
}).$mount("#app");
